import { render } from "./ProfilePermissionForm.vue?vue&type=template&id=0862db4d&scoped=true&ts=true"
import script from "./ProfilePermissionForm.vue?vue&type=script&lang=ts"
export * from "./ProfilePermissionForm.vue?vue&type=script&lang=ts"

import "./ProfilePermissionForm.vue?vue&type=style&index=0&id=0862db4d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0862db4d"]])

export default __exports__